export default __webpack_public_path__ + "static/American_Automobile_Association_Logo-49bf45f797f2330735b513e590a93b45.png";